import { downloadFormsSlice } from "../reducers/downloadFormsSlice";

export const setIsConfirmToDownloadPopUp = (data) => async (dispatch) => {
  dispatch(downloadFormsSlice.actions.setIsConfirmToDownloadPopUp(data));
};
